<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <current-mother :info="resource" :edit="edit" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mother-request-edit :info="resource" :edit="edit" />
        </div>
      </div>
      <div
        class="row"
        v-if="
          record.is_approvable == 1 &&
            record.request_status != 'Approved' &&
            record.request_status != 'Rejected'
        "
      >
        <div class="col-md-12 text-right">
          <ts-button color="danger" @click="showReasonForm(2, record)">{{
            $t('reject')
          }}</ts-button>
          <ts-button
            class="ml-2"
            color="primary"
            @click.prevent="showReasonForm(1, record)"
            >{{ $t('approve') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import CurrentMother from './profile-approval/mother_current_info'
import MotherRequestEdit from './profile-approval/mother_request_edit'
import ReasonComponent from './approval-reason'

export default {
  name: 'viewEditDetailMother',
  props: ['record'],
  components: {
    CurrentMother,
    MotherRequestEdit
  },
  data() {
    return {
      show_comment_input: false,
      loading: false,
      waiting: false,
      nationality_fetch: false,
      occupation_fetch: false,
      province_fetch: false,
      edit: [],
      resource: [],
      districts: [],
      communes: [],
      villages: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('parentProfile', [
      'getNationality',
      'getOccupation',
      'getProvince'
    ]),
    async fetchData() {
      this.loading = true
      await this.getNationality().finally(() => {
        this.nationality_fetch = false
      })
      await this.getOccupation().finally(() => {
        this.occupation_fetch = false
      })
      await this.getProvince().finally(() => {
        this.province_fetch = false
      })
      await this.$store
        .dispatch('home/staffMyApproval/findProfile', this.record.request_id)
        .then(response => {
          this.loading = false

          this.resource = response.parent
          this.edit = response.edit_details
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkKeyExist(key) {
      let result = this.edit.filter(e => e.column_name == key)
      if (result.length > 0) {
        return {
          edit: true,
          value: result[0].new_value
        }
      }
      return {
        edit: false,
        value: null
      }
    },
    getDistrict(code) {
      if (code) {
        this.$store
          .dispatch('parentProfile/getDistrict', code)
          .then(response => {
            this.$store.commit(
              'home/staffMyApproval/SET_DISTRICTS',
              response.data
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    getCommune(code) {
      if (code) {
        this.$store
          .dispatch('parentProfile/getCommune', code)
          .then(response => {
            this.$store.commit(
              'home/staffMyApproval/SET_COMMUNES',
              response.data
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    getVillage(code) {
      if (code) {
        this.$store
          .dispatch('parentProfile/getVillage', code)
          .then(response => {
            this.$store.commit(
              'home/staffMyApproval/SET_VILLAGES',
              response.data
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    showReasonForm(app_status_id, data) {
      this.$emit('close')
      this.$modal.show(
        ReasonComponent,
        {
          app_status_id: app_status_id,
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  },
  watch: {
    edit: function(value) {
      if (value) {
        this.getDistrict(this.checkKeyExist('province_code').value)
        this.getCommune(this.checkKeyExist('district_code').value)
        this.getVillage(this.checkKeyExist('commune_code').value)
      }
    }
  }
}
</script>
<style lang="css" scoped>
.image {
  width: 100px;
  border-radius: 5px;
  padding: 3px;
  background: white;
  margin-top: 20px;
  border: 1px solid gray;
}
.border-red {
  border: 2px solid rgb(125, 141, 69) !important;
}
.has-error {
  border: 1px solid red;
}
</style>
